import type { classDataProps } from "../types/common";

// 學測/模考書籍(kanban 107204)。UI 上與一般書相同(照 getBooks 順序排在書籍輪播),
// 差別只在班級/紀錄的資料行為(見下)。書籍資料由後端建立(2026-07-06 正式命名)。
export const EXAM_BLOCK_BOOK_IDS: readonly string[] = [
  "歷屆學測國寫試題",
  "歷屆模考國寫試題",
];

// 學測/模考書班級沿用陪練國寫 I/II 舊班級(+新書自建班級),見設計文件 D4
export const EXAM_CLASS_SOURCE_BOOK_IDS: readonly string[] = [
  "陪練國寫",
  "陪練國寫(二)",
  ...EXAM_BLOCK_BOOK_IDS,
];

export const isExamBlockBook = (bookId: string) =>
  EXAM_BLOCK_BOOK_IDS.includes(bookId);

export const classBelongsToBook = (cls: classDataProps, bookId: string) =>
  isExamBlockBook(bookId)
    ? EXAM_CLASS_SOURCE_BOOK_IDS.includes(cls.bookID)
    : cls.bookID === bookId;

export const classesForBook = (classes: classDataProps[], bookId: string) =>
  classes.filter((c) => c && classBelongsToBook(c, bookId));

// 只認這本書自己的班級(kanban 106957)。
//
// 用途沿革:原為批次上傳的選班清單,依 PM 2026-08-04「班級以書籍為概念,首次書籍
// 批次上傳,進入後應無法看到其他書籍的已派班級」而設。但派出作文與檢視紀錄都留在
// classesForBook,三個入口兩種答案,老師在派出作文選得到、回批次上傳卻選不到同一個班;
// 2026-08-26 PM 回報此矛盾後,選班清單改回 classesForBook(見 BatchUpload)。
//
// 現在的唯一用途是**建班時的重名比對**:同一本書內同名班會讓老師自己看混,跨書同名
// 則無妨(容器唯一性是 creatorID+bookID+classCode,不看班名)。所以比對範圍要窄,
// 與顯示用的清單分開,不要為了「都用同一份」而合併。
export const classesForUpload = (classes: classDataProps[], bookId: string) =>
  classes.filter((c) => c && c.bookID === bookId);

// getClassRecords 的 bookId 參數:專區書籍需覆寫(舊班級開通碼推導不到新書)
export const classRecordsBookParam = (bookId: string) =>
  isExamBlockBook(bookId) ? bookId : undefined;

// 舊書的考題章節已於 2026-07-03 遷移到新書並刪除,但內容資料同步會整批重建
// 章節文件、把它們復活(2026-07-13 實證:7/6 全量重建)。資料來源治本前,前端
// 一律過濾舊書裡的考題章節,避免同一題出現兩個上傳入口、紀錄散落兩本書。
// 判斷方式鏡射遷移腳本 classify_source 的考題 pattern:考題章節的 source 是
// 「107 學測」「114 模考」之類(以 學測/模考 結尾)→ 只有明確命中才過濾;
// 其餘(含 source 為書名、undefined、空字串、全形括號等變體)一律保留,
// 避免課次章節被靜默隱藏(kanban 113525)。
const OLD_EXAM_SOURCE_BOOKS: readonly string[] = ["陪練國寫", "陪練國寫(二)"];

const MIGRATED_EXAM_SOURCE_PATTERN = /學測$|模考$/;

export const filterMigratedExamChapters = <T extends { source?: string }>(
  bookId: string,
  chapters: T[],
): T[] =>
  OLD_EXAM_SOURCE_BOOKS.includes(bookId)
    ? chapters.filter((c) => !MIGRATED_EXAM_SOURCE_PATTERN.test(c.source ?? ""))
    : chapters;
